import React, { Component } from "react";
import { connect } from "react-redux";
import Chart from "react-apexcharts";
import FloatingButton from "../Material/FloatingButton";
import $ from "jquery";
import Spinner from "react-bootstrap/Spinner";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: false,
      donutpreviousYear: 0,
      donutcurrentYear: 0,
      donutNextYear: 0,
      series1: [0, 0, 0, 0],
      series2: [0, 0],
      options1: {
        chart: {
          type: "donut",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.chartRedirect(config.w.config.labels[config.dataPointIndex]);
            },
          },
        },
        labels: ["Draft", "Pending", "Approved", "Rejected", "Cancelled"],
        plotOptions: {
          pie: {
            donut: {
              size: "50px",
            },
          },
        },
        legend: {
          position: "right",
        },

        dataLabels: {
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      options2: {
        chart: {
          type: "donut",
          size: "50px",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.chartRedirect(config.w.config.labels[config.dataPointIndex]);
            },
          },
        },
        labels: ["Returnable", "Non-Returnable"],
        plotOptions: {
          pie: {
            donut: {
              size: "55px",
            },
          },
        },
        legend: {
          position: "bottom",
        },

        dataLabels: {
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      draft_count: 0,
      revision_count: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Spinner
            animation="border"
            variant="primary"
            className="dashboard-count-spinner"
          />
        </div>
      ),
      pending_count: 0,
      approved_count: 0,
      rejected_count: 0,
      cancelled_count: 0,
      pending_goods_return_count: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Spinner
            animation="border"
            variant="primary"
            className="dashboard-count-spinner"
          />
        </div>
      ),
      Pending_confirm_goods_return_count: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <Spinner
            animation="border"
            variant="primary"
            className="dashboard-count-spinner"
          />
        </div>
      ),
      mypending_count: 0,
      myapproved_count: 0,
      myrejected_count: 0,
      userRole: this.props.userType,
      isGGPStatus: "",
      isGGPCategory: "",
      dashboardGGPStatusYear: "",

      GGPStatus: (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <img
              className="mt-2"
              alt="Draft"
              src={
                process.env.REACT_APP_ENV +
                "/assets/images/charts/disabledChart.png"
              }
            />{" "}
          </div>{" "}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {" "}
            <ul style={{ verticalAlign: "bottom" }}>
              {" "}
              <li
                style={{
                  color: "#c7cac9",
                  display: "inline-block",
                  textAlign: "center",
                  paddingLeft: "2px",
                }}>
                <i class="fa fa-circle fontss"></i> Approved
              </li>{" "}
              <li
                style={{
                  color: "#c7cac9",
                  display: "inline-block",
                  textAlign: "center",
                  paddingLeft: "2px",
                }}>
                <i class="fa fa-circle fontss"></i> Pending
              </li>{" "}
              <li
                style={{
                  color: "#c7cac9",
                  display: "inline-block",
                  textAlign: "center",
                  paddingLeft: "2px",
                }}>
                <i class="fa fa-circle fontss"></i> Rejected
              </li>{" "}
              <li
                style={{
                  color: "#c7cac9",
                  display: "inline-block",
                  textAlign: "center",
                  paddingLeft: "2px",
                }}>
                <i class="fa fa-circle fontss"></i> Cancelled
              </li>{" "}
            </ul>{" "}
          </div>{" "}
        </div>
      ),

      GGPCategory: (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <img
              className="mt-2"
              alt="Draft"
              src={
                process.env.REACT_APP_ENV +
                "/assets/images/charts/disabledChart.png"
              }
            />
          </div>{" "}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {" "}
            <ul style={{ verticalAlign: "bottom" }}>
              {" "}
              <li
                style={{
                  color: "#c7cac9",
                  display: "inline-block",
                  textAlign: "center",
                  padding: "2px",
                }}>
                <i class="fa fa-circle"></i> Returnable
              </li>{" "}
              <li
                style={{
                  color: "#c7cac9",
                  display: "inline-block",
                  textAlign: "center",
                  padding: "2px",
                }}>
                <i class="fa fa-circle"></i> Non-Returnable
              </li>{" "}
            </ul>{" "}
          </div>{" "}
        </div>
      ),
    };
  }

  chartRedirect = (label) => {
    if (label === "Draft") {
      this.viewDraft();
    } else if (label === "Pending") {
      this.viewPending();
    } else if (label === "Rejected") {
      this.viewRejected();
    } else if (label === "Cancelled") {
      this.viewCancelled();
    } else if (label === "Approved") {
      this.viewApproved();
    }
  };

  createSpinnerElement() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <Spinner
          animation="border"
          variant="primary"
          className="dashboard-count-spinner"
        />
      </div>
    );
  }

  donutYearBind = () => {
    let tdyDate = new Date();
    let thisYear = tdyDate.getFullYear();
    let prevYear = parseInt(thisYear - 1);
    let nextYear = parseInt(thisYear + 1);
    this.setState({
      donutcurrentYear: thisYear,
      donutNextYear: nextYear,
      donutpreviousYear: prevYear,
      dashboardGGPCategoryYear: thisYear,
    });
  };

  customRedirect = (myLocation) => {
    window.location = process.env.REACT_APP_ENV + myLocation;
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.dashboardGGPStatusYear !== this.state.dashboardGGPStatusYear
    ) {
      this.GetApplicationCount();
      this.GetMyTaskCount();
    }
  }

  componentDidMount() {
    $('[data-toggle="tooltip"]').tooltip();
    this.props.dispatch({ type: "headerTitle", value: "Dashboard" });
    this.GetApplicationCount();
    // this.fetchUserType();
    this.GetMyTaskCount();
    this.donutYearBind();
    localStorage.removeItem("donuts_ggpstatus");
    localStorage.removeItem("donuts_category");
    localStorage.removeItem("donuts_approvalstatus");
  }

  GetApplicationCount = () => {
    try {
      let postData = {
        UserId: this.props.UserId,
        year:
          this.state.dashboardGGPStatusYear != ""
            ? this.state.dashboardGGPStatusYear
            : null,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/Dashboard/MyApplicationCount",
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject?.[0]) {
            const resultObject = data?.resultObject?.[0];
            this.setState({
              draft_count: resultObject.draft_count,
              pending_count: resultObject.pending_count,
              approved_count: resultObject.approved_count,
              rejected_count: resultObject.rejected_count,
              cancelled_count: resultObject.cancelled_count,
              GGPStatus: (
                <Chart
                  options={this.state.options1}
                  series={[
                    resultObject.draft_count,
                    resultObject.pending_count,
                    resultObject.approved_count,
                    resultObject.rejected_count,
                    resultObject.cancelled_count,
                  ]}
                  type="donut"
                  height="320"
                />
              ),
            });
            if (
              data?.resultObject?.[0]?.draft_count > 0 ||
              data?.resultObject?.[0]?.pending_count > 0 ||
              data?.resultObject?.[0]?.approved_count > 0 ||
              data?.resultObject?.[0]?.rejected_count > 0 ||
              data?.resultObject?.[0]?.cancelled_count > 0
            ) {
              return null;
            } else {
              this.setState({
                GGPStatus: (
                  <div style={{ maxHeight: "300px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                      <img
                        className="mt-2"
                        alt="Draft"
                        src={
                          process.env.REACT_APP_ENV +
                          "/assets/images/charts/disabledChart.png"
                        }
                      />{" "}
                    </div>{" "}
                  </div>
                ),
              });
            }
          } else {
            this.setState({
              draft_count: this.createSpinnerElement(),
              pending_count: this.createSpinnerElement(),
              approved_count: this.createSpinnerElement(),
              rejected_count: this.createSpinnerElement(),
              cancelled_count: this.createSpinnerElement(),
            });
          }
        })

        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  fetchUserType = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Dashboard/Employeedetails?EmployeeId=${this.props.UserId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.props.dispatch({
              type: "userType",
              value: data?.resultObject.userType,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  GetMyTaskCount = () => {
    try {
      let postData = {
        UserId: this.props.UserId,
        year:
          this.state.dashboardGGPStatusYear != ""
            ? this.state.dashboardGGPStatusYear
            : 0,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/Dashboard/MyTaskCount",
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject?.[0]) {
            this.setState({
              mypending_count: data?.resultObject?.[0]?.pending_count,
              myapproved_count: data?.resultObject?.[0]?.approved_count,
              myrejected_count: data?.resultObject?.[0]?.rejected_count,
            });
          } else {
            this.setState({
              mypending_count: this.createSpinnerElement(),
              myapproved_count: this.createSpinnerElement(),
              myrejected_count: this.createSpinnerElement(),
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  mytaskPending = () => {
    window.location = process.env.REACT_APP_ENV + "/mytask/pending/list";
  };

  mytaskApproved = () => {
    window.location = process.env.REACT_APP_ENV + "/mytask/approved/list";
  };

  mytaskRejected = () => {
    window.location = process.env.REACT_APP_ENV + "/mytask/rejected/list";
  };

  viewDraft = () => {
    window.location = process.env.REACT_APP_ENV + "/draft/list";
  };

  viewRevision = () => {
    window.location = process.env.REACT_APP_ENV + "/revision/list";
  };

  viewPending = () => {
    window.location = process.env.REACT_APP_ENV + "/pending/list";
  };

  viewApproved = () => {
    window.location = process.env.REACT_APP_ENV + "/approved/list";
  };

  viewRejected = () => {
    window.location = process.env.REACT_APP_ENV + "/rejected/list";
  };

  viewCancelled = () => {
    window.location = process.env.REACT_APP_ENV + "/cancelled/list";
  };

  handleChange = (e) => {
    switch (e.target.name) {
      case "dashboardGGPStatusYear":
        this.setState({ ...this.state, filter: true });
        this.setState({ dashboardGGPStatusYear: e.target.value });
        break;

      default:
        break;
    }
  };

  render() {
    return (
      <>
        <div>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item" aria-current="page">
                Dashboard
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-sm-12">
              <div className="card-2 box-shadow-1">
                <div className="card-heading-1 clearfix">
                  <h4 className="mb-3 float-left"> My Application </h4>
                  <div className="dropdown dropdown-sm float-right">
                    <div className="selectWrapper">
                      <select
                        className="selectBox"
                        name="dashboardGGPStatusYear"
                        id="dashboardGGPStatusYear"
                        value={
                          this.state.filter == false
                            ? null
                            : this.state.dashboardGGPStatusYear
                        }
                        onChange={this.handleChange}>
                        <option value={0}>All</option>
                        <option value={this.state.donutpreviousYear}>
                          {this.state.donutpreviousYear}
                        </option>
                        <option value={this.state.donutcurrentYear}>
                          {this.state.donutcurrentYear}
                        </option>
                        <option value={this.state.donutNextYear}>
                          {this.state.donutNextYear}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="card-body-1 border-top p-sm-2">
                  {this.state.GGPStatus}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {/* <h3 className="heading-2"> My Application </h3> */}
              <div className="card-1 box-shadow-1">
                <div
                  className="row no-gutters"
                  style={{ justifyContent: "space-around" }}>
                  <div className="col-sm-2">
                    <div
                      className="status-box mouse-pointer"
                      onClick={this.viewDraft}>
                      <div className="icon-sec">
                        <img
                          className="mt-2"
                          style={{ maxHeight: "61px" }}
                          alt="Draft"
                          src={
                            process.env.REACT_APP_ENV +
                            "/assets/images/icons/status/drat-icon.png"
                          }
                        />
                      </div>
                      <div className="stat-sec w-100">
                        <p className="status-count">
                          {" "}
                          {this.state.draft_count}{" "}
                        </p>
                        <p className="status-label"> Draft </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-2">
                    <div
                      className="status-box mouse-pointer"
                      onClick={this.viewPending}>
                      <div className="icon-sec">
                        <img
                          className="mt-2"
                          style={{ maxHeight: "61px" }}
                          alt="Pending"
                          src={
                            process.env.REACT_APP_ENV +
                            "/assets/images/icons/status/pending-icon.png"
                          }
                        />
                      </div>
                      <div className="stat-sec w-100">
                        <p className="status-count">
                          {" "}
                          {this.state.pending_count}{" "}
                        </p>
                        <p className="status-label"> Pending </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div
                      className="status-box mouse-pointer"
                      onClick={this.viewApproved}>
                      <div className="icon-sec">
                        <img
                          className="mt-2"
                          style={{ maxHeight: "61px" }}
                          alt="Approved"
                          src={
                            process.env.REACT_APP_ENV +
                            "/assets/images/icons/status/approved-icon.png"
                          }
                        />
                      </div>
                      <div className="stat-sec w-100">
                        <p className="status-count">
                          {" "}
                          {this.state.approved_count}{" "}
                        </p>
                        <p className="status-label"> Approved </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div
                      className="status-box mouse-pointer"
                      onClick={this.viewRejected}>
                      <div className="icon-sec">
                        <img
                          className="mt-2"
                          style={{ maxHeight: "61px" }}
                          alt="Rejected"
                          src={
                            process.env.REACT_APP_ENV +
                            "/assets/images/icons/status/rejected-icon.png"
                          }
                        />
                      </div>
                      <div className="stat-sec w-100">
                        <p className="status-count">
                          {" "}
                          {this.state.rejected_count}{" "}
                        </p>
                        <p className="status-label"> Rejected </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div
                      className="status-box border-0 mouse-pointer"
                      onClick={this.viewCancelled}>
                      <div className="icon-sec">
                        <img
                          className="mt-2"
                          style={{ maxHeight: "61px" }}
                          alt="Cancelled"
                          src={
                            process.env.REACT_APP_ENV +
                            "/assets/images/icons/status/cancelled-icon.png"
                          }
                        />
                      </div>
                      <div className="stat-sec w-100">
                        <p className="status-count">
                          {" "}
                          {this.state.cancelled_count}{" "}
                        </p>
                        <p className="status-label"> Cancelled </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <h3 className="heading-2"> My Task </h3>
              <div className="card-1 box-shadow-1">
                <div
                  className="row no-gutters"
                  style={{ justifyContent: "space-around" }}>
                  <div className="col-sm-3">
                    <div
                      className="status-box mouse-pointer"
                      onClick={() =>
                        (window.location =
                          process.env.REACT_APP_ENV + "/mytask/pending/list")
                      }>
                      <div className="icon-sec">
                        <img
                          className="mt-2"
                          style={{ maxHeight: "61px" }}
                          alt="Pending"
                          src={
                            process.env.REACT_APP_ENV +
                            "/assets/images/icons/status/pending-icon.png"
                          }
                        />
                      </div>
                      <div
                        className="stat-sec w-100"
                        style={{ paddingRight: "9rem" }}>
                        <p className="status-count">
                          {" "}
                          {this.state.mypending_count}{" "}
                        </p>
                        <p className="status-label"> Pending </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div
                      className="status-box mouse-pointer"
                      onClick={() =>
                        (window.location =
                          process.env.REACT_APP_ENV + "/mytask/approved/list")
                      }>
                      <div className="icon-sec">
                        <img
                          className="mt-2"
                          style={{ maxHeight: "61px" }}
                          alt="Approved"
                          src={
                            process.env.REACT_APP_ENV +
                            "/assets/images/icons/status/approved-icon.png"
                          }
                        />
                      </div>
                      <div
                        className="stat-sec w-100"
                        style={{ paddingRight: "9rem" }}>
                        <p className="status-count">
                          {" "}
                          {this.state.myapproved_count}{" "}
                        </p>
                        <p className="status-label"> Approved </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div
                      className="status-box mouse-pointer"
                      onClick={() =>
                        (window.location =
                          process.env.REACT_APP_ENV + "/mytask/rejected/list")
                      }>
                      <div className="icon-sec">
                        <img
                          className="mt-2"
                          style={{ maxHeight: "61px" }}
                          alt="Rejected"
                          src={
                            process.env.REACT_APP_ENV +
                            "/assets/images/icons/status/rejected-icon.png"
                          }
                        />
                      </div>
                      <div
                        className="stat-sec w-100"
                        style={{ paddingRight: "9rem" }}>
                        <p className="status-count">
                          {" "}
                          {this.state.myrejected_count}{" "}
                        </p>
                        <p className="status-label"> Rejected </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(Dashboard);
